export default __webpack_public_path__ + "static/media/Hero's Hellglaive.e42bfe47.jpg";